import { render, staticRenderFns } from "./RegionList.vue?vue&type=template&id=734d7a8e"
import script from "./RegionList.vue?vue&type=script&lang=ts"
export * from "./RegionList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports